var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.888 9.75 5.034-5.034v3.681h1V4.055l-1.045-1.046H7.535v1h3.68L6.181 9.044l.707.707ZM5.085 5.198h.549v-1H4.67l-.147.147L3.078 5.79v5.608L4.67 12.99h5.607l1.593-1.593v-.918h-1v.503l-1.007 1.008H5.085l-1.007-1.008V6.205l1.007-1.008Z",
    fill: "currentColor"
  })));
};
export default SvgShare;